function ForStudents(theme) {
  return (
    "data:image/svg+xml;base64," +
    window.btoa(`<svg
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                viewBox="0 0 687 550"
                style="enable-background: new 0 0 687 550"
                xml:space="preserve"
            >
                <style>
                    .st4 { fill: none; }
                    .st4, .st5 { stroke: ${theme.icon}; stroke-width: 6; }
                    .st5, .st6 { fill: ${theme.icon}; }
                    .st7 { fill: none; stroke: ${theme.icon}; }
                </style>
                <path style="fill: ${theme.background1}" d="M0 0h687v550H0z" />
                <path d="M687 134v416H340l347-416z" style="fill: ${theme.background2}" />
                <path d="M687 .6v182L2 .6h685z" style="fill: ${theme.background3}" />
                <path d="m0 364 687 186H0V364z" style="fill: ${theme.background4}" />
                <path
                    class="st4"
                    d="M409.7 196.3c0 14.4-12.8 26.4-29 26.4-16.3 0-29-12.1-29-26.4 0-14.4 12.8-26.4 29-26.4 16.3 0 29 12.1 29 26.4z"
                />
                <path
                    class="st5"
                    d="M439 261.9c0 2.3-1.1 4.5-3.7 6.5-2.7 2.1-6.7 3.9-12.1 5.4-10.7 2.9-25.8 4.2-42.8 4.2-17 0-31.8-1.3-42.2-4.2-5.2-1.5-9.2-3.3-11.7-5.4-2.5-2-3.5-4.2-3.5-6.5 0-2.5 1.2-5.6 3.9-8.8 2.7-3.2 6.8-6.5 12-9.4 10.4-5.8 25-10 41.6-10s31.5 4.2 42.1 10c5.3 2.9 9.5 6.2 12.3 9.4 2.9 3.3 4.1 6.3 4.1 8.8z"
                />
                <path class="st6" d="M349.9 171.7h61.6v15.2h-61.6z" />
                <path class="st6" d="m338.9 172 42-13 39.1 13-39.1 10.1-42-10.1z" />
                <path class="st7" d="M340.9 176.6v-4.9" />
                <circle class="st6" cx="341" cy="177.5" r="1.5" />
                <path class="st6" d="m341 176.6 1.8 23.5-1.8 5.6-1.8-5.6 1.8-23.5z" />
                <path
                    class="st4"
                    d="M114.7 196.3c0 14.4-12.8 26.4-29 26.4-16.3 0-29-12.1-29-26.4 0-14.4 12.8-26.4 29-26.4 16.3 0 29 12.1 29 26.4z"
                />
                <path
                    class="st5"
                    d="M144 261.9c0 2.3-1.1 4.5-3.7 6.5-2.7 2.1-6.7 3.9-12.1 5.4-10.7 2.9-25.8 4.2-42.8 4.2-17 0-31.8-1.3-42.2-4.2-5.2-1.5-9.2-3.3-11.7-5.4-2.5-2-3.5-4.2-3.5-6.5 0-2.5 1.2-5.6 3.9-8.8 2.7-3.2 6.8-6.5 12-9.4 10.4-5.8 25-10 41.6-10s31.5 4.2 42.1 10c5.3 2.9 9.5 6.2 12.3 9.4 2.9 3.3 4.1 6.3 4.1 8.8z"
                />
                <path class="st6" d="M54.9 171.7h61.6v15.2H54.9z" />
                <path class="st6" d="m43.9 172 42-13 39.1 13-39.1 10.1-42-10.1z" />
                <path class="st7" d="M45.9 176.6v-4.9" />
                <circle class="st6" cx="46" cy="177.5" r="1.5" />
                <path class="st6" d="m46 176.6 1.8 23.5-1.8 5.6-1.8-5.6 1.8-23.5z" />
                <path
                    class="st4"
                    d="M281 207.5c0 24.9-21.9 45.5-49.5 45.5S182 232.4 182 207.5s21.9-45.5 49.5-45.5 49.5 20.6 49.5 45.5z"
                />
                <path
                    class="st5"
                    d="M329 315.5c0 4.6-2.2 8.6-6.8 12.2-4.6 3.7-11.6 6.8-20.5 9.2-17.8 4.9-42.7 7.1-70.6 7.1-27.9 0-52.3-2.2-69.7-7.1-8.7-2.5-15.4-5.5-19.9-9.2-4.4-3.6-6.5-7.6-6.5-12.3 0-4.8 2.3-10.2 6.9-15.8 4.6-5.6 11.5-11.1 20.1-15.9 17.3-9.7 41.6-16.8 69.1-16.8 27.5 0 52.2 7 70 16.8 8.9 4.9 15.9 10.4 20.7 15.9 4.9 5.7 7.2 11.1 7.2 15.9z"
                />
                <path class="st6" d="M181 167h101v25H181z" />
                <path class="st6" d="m163 167.4 68.9-21.4 64.1 21.4-64.1 16.6-68.9-16.6z" />
                <path class="st7" d="M166.5 175v-8" />
                <circle class="st6" cx="166.5" cy="176.5" r="2.5" />
            </svg>`)
  );
}

function ForCompanies(theme) {
  return (
    "data:image/svg+xml;base64," +
    window.btoa(`
<svg
    enable-background="new 0 0 687.5 550"
    viewBox="0 0 687.5 550"
    xml:space="preserve"
    xmlns="http://www.w3.org/2000/svg"
>
    <style type="text/css">
        .st0 {
            fill: ${theme.background5};
        }
        .st29 {
            fill: ${theme.background6};
        }
        .st30 {
            fill: ${theme.background7};
        }
        .st31 {
            fill: ${theme.background8};
        }
    </style>
    <path class="st0" d="m0 0h687.5v550h-687.5z" />
    <path class="st29" d="m0 9h276l-151 540h-125z" />
    <path class="st30" d="M 688,0 0,226 V 0 Z" />
    <path class="st31" d="m0 423 553 127h-553z" />

    <g stroke="${theme.icon}" stroke-linecap="round" stroke-width="8">
        <g fill="none">
            <path d="m241.01 448h401.98" />
            <g stroke-linejoin="round">
                <path d="m313.63 261.28h80.081v186.72h-80.081z" />
                <path d="m491.63 260.98h80.081v186.72h-80.081z" />
                <path d="m393.72 142.6h97.916v305.4h-97.916z" />
            </g>
        </g>
        <g fill="${theme.icon}" stroke-linejoin="round" stroke-miterlimit="5">
            <path d="m510.04 285.92h43.263v22.263h-43.263z" />
            <path d="m510.04 329.12h43.263v22.263h-43.263z" />
            <path d="m510.04 372.32h43.263v22.263h-43.263z" />
            <path d="m332.04 372.32h43.263v22.263h-43.263z" />
            <path d="m332.04 329.12h43.263v22.263h-43.263z" />
            <path d="m332.04 286.04h43.263v22.263h-43.263z" />
            <path d="m415.33 297.64h54.686v23.415h-54.686z" />
            <path d="m415.33 254.44h54.686v23.415h-54.686z" />
            <path d="m415.33 211.24h54.686v23.415h-54.686z" />
            <path d="m415.33 168.04h54.686v23.415h-54.686z" />
            <path d="m458.07 369.06v78.68h-30.796v-78.68z" />
        </g>
    </g>
</svg>
`)
  );
}
export { ForStudents, ForCompanies };
